var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-container clearfix"},[_c('LeftBar'),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.gameUrl},on:{"load":_vm.iframeLoad}}),_vm._v(" "),_c('PayPop'),_vm._v(" "),_c('GPayPop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }